<template>
	<div style="padding-bottom: 15px;">
		<van-sticky>
			<navbar :title="title" />
		</van-sticky>

		<leave v-if="fromList[0].show" ref="childclear" :rform="form" />
		<cost v-if="fromList[1].show" ref="childclear" :rform="form" />
		<travel v-if="fromList[2].show" ref="childclear" :rform="form" />
		<report v-if="fromList[3].show" ref="childclear" :rform="form" />
		<margin v-if="fromList[4].show" ref="childclear" :rform="form" />
		<purchase v-if="fromList[5].show" ref="childclear" :rform="form" />
		<chapter v-if="fromList[6].show" ref="childclear" :rform="form" />
		<Reimburse v-if="fromList[7].show" ref="childclear" :rform="form" />

		<van-steps class="steps" direction="vertical" :active="active" :active-icon="icon" :active-color="color">
			<van-step v-for="(item, index) in node_list" :key="index">
				<h3>
					<van-icon name="manager-o" />
					{{ item.approval_user }}
				</h3>
				<p>
					<van-icon name="aim" />
					{{ status[item.approval_status] }}
				</p>
				<p>
					<van-icon name="underway-o" />
					{{ item.approval_date }}
				</p>
			</van-step>
		</van-steps>

		<audit-btn v-if="auditShow" @audit="auditcheck" :mess="false" ></audit-btn>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import auditBtn from "@/components/auditBtn/index";
import { derails } from "@/api/review";
import { Toast } from "vant";
import leave from "./echo/take_leave";
import cost from "./echo/cost";
import travel from "./echo/travel";
import report from "./echo/report";
import margin from "./echo/margin";
import purchase from "./echo/purchase";
import chapter from "./echo/chapter";
import Reimburse from "./echo/Reimburse";

export default {
	components: {
		navbar,
		leave,
		cost,
		travel,
		report,
		margin,
		purchase,
		chapter,
		Reimburse,
		"audit-btn": auditBtn
	},
	data() {
		return {
			form: {},
			title: "流程详情",
			fromList: [
				{ show: false },
				{ show: false },
				{ show: false },
				{ show: false },
				{ show: false },
				{ show: false },
				{ show: false },
				{ show: false }
			],
			node_list: [],
			status: ["未审批", "通过", "拒绝"],
			icon: "checked",
			color: "#07c160",
			buttonShow: false,
			active: 0,
			apply_node_id: "",
			auditShow: false,
		};
	},
	mounted() {
		this.fromShow();
		this.getDetails();
		this.auditShow = this.$route.query.p;//URL的P值等于是否显示审批按钮
	},
	methods: {
		auditcheck(val) {
			this.approval(val);
		},
		fromShow() {
			this.fromList[this.$route.query.type].show = true;
		},
		getDetails() {
			derails({
				requestType: "process_apply_list_details",
				apply_id: this.$route.query.id
			})
				.then(res => {
					if (res.obj.apply_status === 2) {
						this.icon = "clear";
						this.color = "#ff976a";
					}
					this.node_list = JSON.parse(res.obj.node_list);
					this.form = JSON.parse(res.obj.apply_data);
					this.form.process_name = res.obj.process_name;

					if (this.$route.query.type == 1) {
						this.form.client_name = res.obj.client_name;
					}
					if (this.$route.query.type == 1 && res.obj.file_list != "") {
						this.form.file_list = JSON.parse(res.obj.file_list);
					}
					// if (this.$route.query.type == 6) {
					// 	this.form.client_name = res.obj.client_name;
					// }

					try {
						if (res.obj.user_name != undefined) {
							this.form.user_name = res.obj.user_name;
						}
					} catch (error) {
						Toast.fail("该页面数据存在异常");
					}
					this.active = this.node_list.length;
					this.apply_node_id = res.obj.apply_node_id;
				})
				.catch(() => {
					return Toast.fail("数据异常");
				});
		},
		approval(mess) {
			let type = 2;
			if (!this.apply_node_id) {
				return Toast.fail("数据异常");
			}

			if (mess == "") {
				type = 1;
			}

			derails({
				requestType: "approval_process",
				apply_node_id: this.apply_node_id,
				approval_status: type
			})
				.then(() => {
					this.$route.params.listRefresh = true;
					this.$router.go(-1);
					return Toast.success("审核成功!");
				})
				.catch(() => {
					return Toast.fail("数据异常");
				});
		},
	}
};
</script>

<style lang="scss" scoped>
.button-body {
	padding: 0 15%;
	margin-top: 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.steps {

	h3,
	p {
		margin: 0;
		font-weight: normal;
		font-size: inherit;
	}
}
</style>
